import type { FC } from "react";

import { VirtualSiteGroupSearchForm } from "src/app/features/VirtualSiteGroup/components/forms/VirtualSiteGroupSearchForm";
import type { VirtualSiteGroupList } from "src/app/features/VirtualSiteGroup/types/VirtualSiteGroupList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { VirtualSiteGroupsTable } from "../components/tables/VirtualSiteGroupTable";

export const VirtualSiteGroupsPage: FC<NoneOwnProps> = () => {
    const table = <VirtualSiteGroupsTable />;
    const searchForm = <VirtualSiteGroupSearchForm />;
    const hasAccess = canAccess(ResourceName.VIRTUAL_SITE_GROUPS, "canRead");

    return (
        <PageLayout name="virtualSiteGroups_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.virtualSiteGroups" />
                    <ResourceManager<VirtualSiteGroupList>
                        useDataGroup
                        dataMapperKey="virtualSiteGroupsTableData"
                        resource={ResourceName.VIRTUAL_SITE_GROUPS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
